module.exports = __WEBPACK_EXTERNAL_MODULE__foundation_util_touch__;